import BaseChannelSerializer from '@square/dashboard-data/serializers/channels/base-channel-serializer';
export default class SurveyResponse extends BaseChannelSerializer {
  modelNameFromPayloadKey() {
    return 'channels/survey-response';
  }
}